/* unplugin-vue-components disabled */import { render } from "./Header.vue?vue&type=template&id=1e4e3bb4&scoped=true&ts=true"
import script from "./Header.vue?vue&type=script&lang=ts"
export * from "./Header.vue?vue&type=script&lang=ts"

import "./Header.vue?vue&type=style&index=0&id=1e4e3bb4&lang=scss&scoped=true"

import exportComponent from "/Users/yaogengzhu/Documents/soft-open/software-platform/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1e4e3bb4"]])

export default __exports__